import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView, initClickTracking, sanitizeSearch } from "../../utils/usageTracker";

/**
 * Mounted once inside <Router> (see App.tsx). Fires a `page_view` usage event
 * on every route change so we can see which tabs each user opens. Renders
 * nothing. Only authenticated users are recorded (enforced inside the tracker).
 */
const UsageTracker: React.FC = () => {
  const location = useLocation();
  const prevKey = useRef<string>("");

  // Attach the delegated in-page click listener once.
  useEffect(() => {
    initClickTracking();
  }, []);

  useEffect(() => {
    const key = location.pathname + location.search;
    if (key === prevKey.current) return; // ignore replace/no-op re-renders
    prevKey.current = key;

    trackPageView(
      location.pathname,
      undefined,
      location.search ? { search: sanitizeSearch(location.search).slice(0, 500) } : undefined,
    );
  }, [location.pathname, location.search]);

  return null;
};

export default UsageTracker;
